module.exports = __webpack_public_path__ + "img/20180815_151844_214.79a8136b.jpg";